import makeStyles from '@mui/styles/makeStyles';
import { alpha } from '@mui/material/styles';

const ligherGray = '#cfd8dc';
export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    marginBottom: theme.spacing(1),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  persianAmount: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  AccordionSummary: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttonWrapper: {
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
    borderRadius: 8,
    overflow: 'hidden',
    '& > .MuiButton-root': {
      flex: '1 1 auto',
      minWidth: 0,
      paddingInline: theme.spacing(1),
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',
      border: '0 !important',
      borderRadius: '0 !important',
      margin: '0 !important',
      minHeight: 42,
      lineHeight: '17px',
      whiteSpace: 'normal',
      textAlign: 'center',
      '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        zIndex: 1,
      },
      '&.Mui-disabled': {
        color: theme.palette.action.disabled,
      },
    },
    '& > .MuiButton-root:not(:last-child)': {
      borderInlineEnd: `1px solid ${alpha(theme.palette.primary.main, 0.5)} !important`,
    },
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
      border: 0,
      overflow: 'visible',
      '& > .MuiButton-root': {
        border: `1px solid ${alpha(theme.palette.primary.main, 0.5)} !important`,
      },
    },
  },
  btnLoading: {
    lineHeight: '17px',
    [theme.breakpoints.down('md')]: {
      width: '100% !important',
      borderColor: 'inherit !important',
      margin: `${theme.spacing(1)} !important`,
      borderRadius: '4px !important',
    },
  },
  button: {
    lineHeight: '17px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      borderColor: 'inherit !important',
      margin: `${theme.spacing(1)} !important`,
      borderRadius: '4px !important',
    },
  },
  currencyText: {
    fontSize: 15,
    paddingInlineStart: theme.spacing(1),
  },
  balanceBox: {
    backgroundColor: '#eceff1',
    border: '1px solid #2B3990',
    padding: theme.spacing(2),
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.09)',
    borderRadius: 8,
    backgroundImage: 'url(./images/riyal.svg)',
    backgroundPosition: '-19px center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 75%',
    position: 'relative',
    '&.disabled': {
      backgroundColor: '#eceff152',
      border: '1px solid #929eaa7a',
      backgroundImage: 'url(./images/riyal-grey.svg)',
      boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.04)',
    },
  },
  balanceTitle: {
    color: '#263238',
    fontSize: 14,
    fontWeight: 'bold',
  },
  balancePrice: {
    color: '#263238',
    fontSize: 24,
    fontWeight: 'normal',
    marginTop: theme.spacing(2),
  },
  balanceAmount: {
    direction: 'rtl',
    display: 'inline-block',
  },
  balancePriceText: {
    color: '#263238',
    fontSize: 12,
    fontWeight: 'normal',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  expiredFlag: {
    background: ligherGray,
    borderBottomLeftRadius: 10,
    padding: theme.spacing(1, 2),
    paddingBottom: theme.spacing(1.5),
    color: '#455b64',
    fontSize: 13,
    position: 'absolute',
    right: 0,
    top: 0,
    fontWeight: 'bold',
  },
  blockedAmount: {
    color: '#263238',
    fontSize: 14,
    fontWeight: 'normal',
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1),
    display: 'flex',
  },
  blockedAmountIcon: {
    color: '#263238',
    fontSize: 16,
    fontWeight: 'normal',
    marginBottom: -5,
    marginInlineEnd: theme.spacing(0.5),
  },
  blockedAmountPre: {
    fontWeight: 'bold',
    display: 'inline-block',
    direction: 'rtl !important',
    marginLeft: theme.spacing(1),
  },

  enlighNum: {
    '& *': {
      fontFamily: 'Vazir',
    },
    '& b': {
      marginInlineStart: theme.spacing(0.5),
    },
  },
  copyIcon: {
    width: 20,
    height: 20,
    margin:'0 10px',
    padding: 0,
  },
  newTokenText: {
    color: '#263238',
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
    background: 'rgb(247, 248, 248)',
    padding: theme.spacing(1.5),
    overflowWrap: 'break-word',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    fontFamily: 'Vazir',
    direction: 'rtl',
  },
  detailPaper: {
    paddingBottom: theme.spacing(1.5),
    boxSizing: 'border-box  ',
  },
}));
